module.exports = __webpack_public_path__ + "img/money copy.d8e2c6df.png";